import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
};

export const attendanceRefreshSlice = createSlice({
    name: 'attendanceRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            state.refresh = action.payload.refresh;
        },
    },
});

export const { setRefresh } = attendanceRefreshSlice.actions;
export default attendanceRefreshSlice.reducer;
